import React from "react";
import {
  Box,
  List,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  ListItemButton,
  CircularProgress,
  Container,
} from "@common-ui/ui";
import { StatusChip } from "./StatusChip";

import { useHistory } from "react-router-dom";

export const WorkEventsListView = (props) => {
  let data = props.rowsData;
  let router = useHistory();
  const listItem = (item, divider = false) => (
    <ListItemButton
      key={item.id}
      divider={divider}
      alignItems="flex-start"
      sx={{ width: "100%", maxWidth: "100%", pl: 0, pr: 0 }}
      style={{ cursor: "pointer" }}
      onClick={() =>
        router.push({
          pathname: `/work-events/${item.for_org}/work-event/${item.id}`,
        })
      }
    >
      <ListItemAvatar>
        <Avatar
          variant="square"
          alt={item.id}
          src={`https://avatars.dicebear.com/v2/initials/${item.id.substr(
            -2
          )}.svg?chars=2`}
        />
      </ListItemAvatar>
      <ListItemText
        primary={item.id}
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.secondary"
            >
              Status: {<StatusChip status={item.status}/>} | Work Items:{" "}
              {item.work_items && item.work_items.length
                ? item.work_items.length
                : 0}
              | Start Date:{" "}
              {new Date(item.scheduled_start_date).toLocaleDateString() || "--"}{" "}
              | End Date:{" "}
              {new Date(item.scheduled_end_date).toLocaleDateString() || "--"}
            </Typography>{" "}
          </React.Fragment>
        }
      />
    </ListItemButton>
  );
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
        }}
      >
        {props.isLoading ? (
          <Container maxWidth="md" component="main">
            <Box sx={{ my: 3 }}>
              <CircularProgress />
            </Box>
          </Container>
        ) : (
          <List
            sx={{
              width: "100%",
              maxWidth: "100%",
              bgcolor: "background.paper",
            }}
          >
            {Array.from(data).map((dataItem, i) => {
              if (i === data.length - 1) {
                return listItem(dataItem);
              }
              return listItem(dataItem, true);
            })}
          </List>
        )}
      </Box>
    </>
  );
};
